import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.cycle.history');
import { HostListener, Input, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-cycle-history',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.cycle.history/view.scss */
.hn-cycle-ledger {
  display: grid;
  gap: 0;
}

.hn-ledger-cycle {
  min-width: 0;
  padding: 10px 0;
}

.hn-ledger-cycle + .hn-ledger-cycle {
  border-top: 1px solid var(--hn-line);
}

.hn-ledger-head {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto 10px;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 44px;
  padding: 4px;
  margin: 0;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--hn-ink);
  cursor: pointer;
  text-align: left;
  font: inherit;
}

.hn-ledger-head:hover {
  background: #f3f5fa;
}

.hn-ledger-head:focus-visible {
  outline: 3px solid #285ddd;
  outline-offset: 2px;
}

.hn-ledger-head > i {
  font-size: 0.625rem;
  color: var(--hn-muted);
}

.hn-ledger-identity {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 5px 7px;
  min-width: 0;
}

.hn-ledger-identity > strong {
  font-size: 0.8125rem;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.hn-ledger-status {
  background: #eee9fa;
  color: #7452a6;
  border-radius: 5px;
  padding: 3px 6px;
  font-size: 0.6875rem;
}

.hn-ledger-status.is-complete {
  background: #eef1f4;
  color: #5b6677;
}

.hn-ledger-result {
  display: grid;
  gap: 3px;
  text-align: right;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
  min-width: 0;
}

.hn-ledger-result small {
  font-size: 0.625rem;
  color: var(--hn-muted);
}

.hn-ledger-result strong {
  font-size: 0.875rem;
  font-weight: 600;
}

.hn-ledger-result .is-positive {
  color: #bd3f3a;
}

.hn-ledger-result .is-negative {
  color: #285ddd;
}

.hn-ledger-meta {
  display: flex;
  flex-basis: 100%;
  flex-wrap: wrap;
  gap: 4px 8px;
  font-size: 0.6875rem;
  color: var(--hn-muted);
}

.hn-ledger-head::-webkit-details-marker {
  display: none;
}

.hn-ledger-details[open] .hn-ledger-head > i {
  transform: rotate(180deg);
}

.hn-ledger-detail-link {
  border: 0;
  background: transparent;
  color: #285ddd;
  padding: 10px 4px;
  min-height: 44px;
  font: inherit;
  font-size: 0.75rem;
  cursor: pointer;
}

.hn-ledger-detail-link:focus-visible {
  outline: 3px solid #285ddd;
  outline-offset: 2px;
}

.hn-ledger-fills {
  list-style: none;
  padding: 0;
  margin: 4px 0 0;
}

.hn-ledger-fills li {
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr) minmax(0, auto);
  align-items: center;
  gap: 8px;
  padding: 7px 4px;
}

.hn-ledger-side {
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border-radius: 9px;
  background: #eff2f6;
  font-size: 1rem;
}

.hn-ledger-side.is-buy {
  color: #285ddd;
  background: #edf2ff;
}

.hn-ledger-side.is-sell {
  color: #267255;
  background: #eaf5ef;
}

.hn-ledger-fill-label, .hn-ledger-fill-value {
  display: grid;
  gap: 3px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.hn-ledger-fill-value {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.hn-ledger-fills strong {
  font-size: 0.75rem;
  font-weight: 500;
}

.hn-ledger-fills time, .hn-ledger-fills small {
  color: var(--hn-muted);
  font-size: 0.625rem;
}

.hn-ledger-empty {
  color: var(--hn-muted);
  font-size: 0.75rem;
  line-height: 1.6;
  margin: 10px 4px 2px;
}

.is-compact .hn-cycle-history__empty {
  min-height: 96px;
  padding: 16px 8px;
  gap: 8px;
}

.is-compact .hn-cycle-history__empty > span {
  width: 30px;
  height: 30px;
  margin: 0;
  font-size: 1rem;
}

.is-compact .hn-cycle-history__empty strong {
  font-size: 0.8125rem;
  font-weight: 400;
}

@media (max-width: 380px) {
  .hn-ledger-head {
    grid-template-columns: minmax(0, 1fr) minmax(0, 0.65fr) 8px;
    gap: 6px;
  }
}
@media (prefers-contrast: more) {
  .hn-ledger-cycle {
    --hn-muted: #455063;
  }
  .hn-ledger-status {
    border: 1px solid currentColor;
  }
}
:host {
  display: block;
}

.hn-cycle-history__grid {
  display: grid;
  gap: 9px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.hn-cycle-summary {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line);
  border-radius: 13px;
  color: var(--hn-ink);
  cursor: pointer;
  display: block;
  min-width: 0;
  overflow: hidden;
  padding: 0;
  text-align: left;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
  width: 100%;
}

.hn-cycle-summary:hover {
  border-color: #b8c993;
  box-shadow: 0 8px 20px rgba(25, 34, 20, 0.07);
  transform: translateY(-1px);
}

.hn-cycle-summary:focus-visible {
  outline: 3px solid #4268c5;
  outline-offset: 3px;
}

.hn-cycle-summary.is-active {
  border-color: #b8c993;
  box-shadow: inset 3px 0 0 var(--hn-accent-deep);
}

.hn-cycle-summary__head,
.hn-cycle-summary__last,
.hn-cycle-summary__metrics,
.hn-cycle-summary__pnl {
  display: flex;
}

.hn-cycle-summary__head {
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 13px 7px;
}

.hn-cycle-summary__head strong,
.hn-cycle-summary__head small {
  display: block;
}

.hn-cycle-summary__head strong {
  font-size: 14px;
  line-height: 1.35;
}

.hn-cycle-summary__head small {
  color: var(--hn-muted);
  font-size: var(--hn-text-caption);
  margin-top: 4px;
}

.hn-cycle-summary__head em,
.hn-cycle-dialog__identity > span {
  background: #fff3df;
  border-radius: 999px;
  color: #80520e;
  font-size: var(--hn-text-caption);
  font-style: normal;
  font-weight: 800;
  padding: 5px 8px;
  white-space: nowrap;
}

.hn-cycle-summary__head em.is-complete,
.hn-cycle-dialog__identity > span.is-complete {
  background: var(--hn-accent-soft);
  color: var(--hn-accent-deep);
}

.hn-cycle-summary__head em.is-unfilled,
.hn-cycle-dialog__identity > span.is-unfilled {
  background: var(--hn-paper-muted);
  color: var(--hn-muted-strong);
}

.hn-cycle-summary__pnl {
  align-items: baseline;
  gap: 8px;
  padding: 3px 13px 11px;
}

.hn-cycle-summary__pnl small {
  color: var(--hn-muted);
  font-size: var(--hn-text-caption);
}

.hn-cycle-summary__pnl strong {
  font-size: 22px;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.035em;
}

.is-positive {
  color: #a93226 !important;
}

.is-negative {
  color: #285dab !important;
}

.hn-cycle-summary__metrics {
  border-top: 1px solid var(--hn-line);
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.hn-cycle-summary__metrics > span {
  padding: 8px 7px 9px;
  text-align: center;
}

.hn-cycle-summary__metrics > span + span {
  border-left: 1px solid var(--hn-line);
}

.hn-cycle-summary__metrics small,
.hn-cycle-summary__metrics strong {
  display: block;
}

.hn-cycle-summary__metrics small {
  color: var(--hn-muted);
  font-size: var(--hn-text-caption);
}

.hn-cycle-summary__metrics strong {
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  margin-top: 3px;
}

.hn-cycle-summary__last {
  align-items: center;
  border-top: 1px solid var(--hn-line);
  gap: 9px;
  min-height: 50px;
  padding: 7px 10px 7px 13px;
}

.hn-cycle-summary__last > span:not(.hn-cycle-summary__side) {
  min-width: 0;
}

.hn-cycle-summary__last strong,
.hn-cycle-summary__last small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hn-cycle-summary__last strong {
  font-size: 14px;
}

.hn-cycle-summary__last small {
  color: var(--hn-muted);
  font-size: var(--hn-text-caption);
  margin-top: 3px;
}

.hn-cycle-summary__last > em {
  color: var(--hn-muted);
  font-size: var(--hn-text-caption);
  font-style: normal;
  margin-left: auto;
  white-space: nowrap;
}

.hn-cycle-summary__last > i {
  color: var(--hn-muted);
  font-size: 11px;
  margin-left: 2px;
}

.hn-cycle-summary__side,
.hn-order-timeline__side {
  border-radius: 7px;
  flex: 0 0 auto;
  font-size: var(--hn-text-caption);
  font-weight: 800;
  padding: 5px 6px;
}

.is-buy {
  background: var(--hn-danger-soft);
  color: #a52f24;
}

.is-sell {
  background: var(--hn-blue-soft);
  color: #2857ae;
}

.hn-cycle-summary__no-fill {
  color: var(--hn-muted-strong);
  font-size: var(--hn-text-caption);
  font-weight: 700;
}

.hn-cycle-history.is-compact .hn-cycle-history__grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.hn-cycle-history.is-compact .hn-cycle-summary__metrics > span:last-child {
  display: none;
}

.hn-cycle-history.is-compact .hn-cycle-summary__metrics {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.hn-cycle-history__empty {
  align-items: center;
  color: var(--hn-muted-strong);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 118px;
  padding: 18px 14px;
  text-align: center;
}

.hn-cycle-history__empty > span {
  align-items: center;
  background: var(--hn-accent-soft);
  border-radius: 13px;
  color: var(--hn-accent-deep);
  display: flex;
  height: 44px;
  justify-content: center;
  margin-bottom: 12px;
  width: 44px;
}

.hn-cycle-history__empty strong {
  font-size: 14px;
}

.hn-cycle-modal {
  align-items: center;
  background: rgba(15, 20, 14, 0.56);
  display: flex;
  inset: 0;
  justify-content: center;
  padding: 16px;
  position: fixed;
  z-index: 1500;
}

.hn-cycle-dialog {
  background: var(--hn-paper);
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 16px;
  box-shadow: 0 30px 90px rgba(12, 17, 10, 0.28);
  display: flex;
  flex-direction: column;
  max-height: min(820px, 100dvh - 32px);
  max-width: 760px;
  overflow: hidden;
  width: 100%;
}

.hn-cycle-dialog__head {
  align-items: center;
  border-bottom: 1px solid var(--hn-line);
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  min-height: 62px;
  padding: 10px 14px 10px 17px;
}

.hn-cycle-dialog__head small {
  color: var(--hn-muted);
  display: block;
  font-size: var(--hn-text-caption);
  font-weight: 700;
}

.hn-cycle-dialog__head h2 {
  font-size: 18px;
  letter-spacing: -0.025em;
  margin: 4px 0 0;
}

.hn-cycle-dialog__head button {
  align-items: center;
  background: var(--hn-paper-muted);
  border: 0;
  border-radius: 50%;
  color: var(--hn-ink);
  display: flex;
  font-size: 16px;
  height: 40px;
  justify-content: center;
  width: 40px;
}

.hn-cycle-dialog__head button:focus-visible,
.hn-cycle-dialog__error button:focus-visible {
  outline: 3px solid #4268c5;
  outline-offset: 2px;
}

.hn-cycle-dialog__body {
  overflow-y: auto;
  overscroll-behavior: contain;
}

.hn-cycle-dialog__loading,
.hn-cycle-dialog__error,
.hn-cycle-dialog__empty {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 170px;
  padding: 20px;
}

.hn-cycle-dialog__loading {
  color: var(--hn-muted-strong);
  flex-direction: column;
  gap: 13px;
}

.hn-cycle-dialog__loading > span {
  animation: hn-cycle-spin 0.8s linear infinite;
  border: 3px solid var(--hn-line);
  border-radius: 50%;
  border-top-color: var(--hn-accent-deep);
  height: 28px;
  width: 28px;
}

@keyframes hn-cycle-spin {
  to {
    transform: rotate(360deg);
  }
}
.hn-cycle-dialog__loading strong {
  font-size: var(--hn-text-body);
}

.hn-cycle-dialog__error {
  color: var(--hn-danger);
  flex-direction: column;
  gap: 12px;
  text-align: center;
}

.hn-cycle-dialog__error > i {
  font-size: 24px;
}

.hn-cycle-dialog__error strong {
  font-size: var(--hn-text-body);
}

.hn-cycle-dialog__error button {
  background: var(--hn-charcoal);
  border: 0;
  border-radius: 9px;
  color: #fff;
  font-size: var(--hn-text-body);
  font-weight: 800;
  min-height: 44px;
  padding: 0 14px;
}

.hn-cycle-dialog__overview {
  background: linear-gradient(150deg, #f8faf6, #f1f5eb);
  border-bottom: 1px solid var(--hn-line);
  padding: 13px 17px 15px;
}

.hn-cycle-dialog__identity {
  align-items: center;
  display: flex;
  gap: 8px;
}

.hn-cycle-dialog__identity small {
  color: var(--hn-muted);
  font-size: var(--hn-text-caption);
}

.hn-cycle-dialog__overview dl {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 12px 0 0;
}

.hn-cycle-dialog__overview dl > div {
  min-width: 0;
}

.hn-cycle-dialog__overview dl > div + div {
  border-left: 1px solid var(--hn-line-strong);
  padding-left: 15px;
}

.hn-cycle-dialog__overview dt {
  color: var(--hn-muted);
  font-size: var(--hn-text-caption);
}

.hn-cycle-dialog__overview dd {
  font-size: var(--hn-text-body);
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  margin: 5px 0 0;
  overflow-wrap: anywhere;
}

.hn-cycle-dialog__orders {
  padding: 15px 17px 0;
}

.hn-cycle-dialog__orders > header {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.hn-cycle-dialog__orders h3,
.hn-cycle-dialog__settlement h3 {
  font-size: 14px;
  margin: 0;
}

.hn-cycle-dialog__orders > header > span {
  color: var(--hn-muted);
  font-size: var(--hn-text-caption);
  font-weight: 700;
}

.hn-order-timeline {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
}

.hn-order-timeline > li {
  display: grid;
  gap: 12px;
  grid-template-columns: 12px minmax(0, 1fr);
  padding-bottom: 13px;
  position: relative;
}

.hn-order-timeline > li::before {
  background: var(--hn-line-strong);
  bottom: -1px;
  content: "";
  left: 5px;
  position: absolute;
  top: 12px;
  width: 2px;
}

.hn-order-timeline > li:last-child::before {
  display: none;
}

.hn-order-timeline__mark {
  border: 3px solid var(--hn-paper);
  border-radius: 50%;
  height: 12px;
  margin-top: 14px;
  position: relative;
  width: 12px;
  z-index: 1;
}

.hn-order-timeline__mark.is-buy {
  background: #bf4b40;
  box-shadow: 0 0 0 1px #dca8a3;
}

.hn-order-timeline__mark.is-sell {
  background: #3970ad;
  box-shadow: 0 0 0 1px #a9c2df;
}

.hn-order-timeline > li > article {
  background: #fafbf8;
  border: 1px solid var(--hn-line);
  border-radius: 13px;
  overflow: hidden;
}

.hn-order-timeline article > header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 51px;
  padding: 9px 13px;
}

.hn-order-timeline article > header > div {
  align-items: center;
  display: flex;
  gap: 8px;
}

.hn-order-timeline article > header strong {
  font-size: var(--hn-text-body);
}

.hn-order-timeline article > header em {
  background: var(--hn-paper-muted);
  border-radius: 999px;
  color: var(--hn-muted-strong);
  font-size: var(--hn-text-caption);
  font-style: normal;
  font-weight: 800;
  padding: 5px 7px;
}

.hn-order-timeline article > dl {
  border-top: 1px solid var(--hn-line);
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 0;
}

.hn-order-timeline article > dl > div {
  min-width: 0;
  padding: 10px 12px;
}

.hn-order-timeline article > dl > div + div {
  border-left: 1px solid var(--hn-line);
}

.hn-order-timeline dt {
  color: var(--hn-muted);
  font-size: var(--hn-text-caption);
}

.hn-order-timeline dd {
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  margin: 3px 0 0;
  overflow-wrap: anywhere;
}

.hn-order-timeline__progress {
  background: var(--hn-paper-muted);
  height: 4px;
  overflow: hidden;
}

.hn-order-timeline__progress span {
  background: var(--hn-accent-deep);
  display: block;
  height: 100%;
}

.hn-order-fills {
  border-top: 1px solid var(--hn-line);
  list-style: none;
  margin: 0;
  padding: 0 12px;
}

.hn-order-fills li {
  align-items: center;
  border-top: 1px solid var(--hn-line);
  display: grid;
  gap: 12px;
  grid-template-columns: 128px minmax(0, 1fr) auto;
  min-height: 43px;
}

.hn-order-fills li:first-child {
  border-top: 0;
}

.hn-order-fills time {
  color: var(--hn-muted);
  font-size: var(--hn-text-caption);
}

.hn-order-fills strong,
.hn-order-fills span {
  font-size: 14px;
  font-variant-numeric: tabular-nums;
}

.hn-order-fills span {
  font-weight: 800;
  text-align: right;
}

.hn-order-timeline footer {
  align-items: center;
  color: var(--hn-muted);
  display: flex;
  flex-wrap: wrap;
  font-size: var(--hn-text-caption);
  gap: 6px 12px;
  justify-content: space-between;
  padding: 9px 12px;
}

.hn-cycle-dialog__empty {
  color: var(--hn-muted);
  min-height: 110px;
}

.hn-cycle-dialog__empty strong {
  font-size: var(--hn-text-body);
}

.hn-cycle-dialog__settlement {
  border-top: 1px solid var(--hn-line);
  margin-top: 5px;
  padding: 14px 17px 17px;
}

.hn-cycle-dialog__settlement dl {
  border: 1px solid var(--hn-line);
  border-radius: 12px;
  margin: 12px 0 0;
  overflow: hidden;
}

.hn-cycle-dialog__settlement dl > div {
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 42px;
  padding: 8px 12px;
}

.hn-cycle-dialog__settlement dl > div + div {
  border-top: 1px solid var(--hn-line);
}

.hn-cycle-dialog__settlement dt {
  color: var(--hn-muted);
  font-size: var(--hn-text-caption);
}

.hn-cycle-dialog__settlement dd {
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  margin: 0;
  text-align: right;
}

@media (max-width: 1050px) {
  .hn-cycle-history__grid,
  .hn-cycle-history.is-compact .hn-cycle-history__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 680px) {
  .hn-cycle-history__grid,
  .hn-cycle-history.is-compact .hn-cycle-history__grid {
    grid-template-columns: 1fr;
  }
  .hn-cycle-modal {
    align-items: flex-end;
    padding: 0;
  }
  .hn-cycle-dialog {
    border-radius: 20px 20px 0 0;
    max-height: calc(100dvh - 24px);
  }
  .hn-cycle-dialog__head {
    min-height: 66px;
    padding: 11px 13px 11px 17px;
  }
  .hn-cycle-dialog__overview {
    padding: 15px 17px 17px;
  }
  .hn-cycle-dialog__overview dl {
    gap: 12px 0;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .hn-cycle-dialog__overview dl > div:nth-child(3) {
    border-left: 0;
    padding-left: 0;
  }
  .hn-cycle-dialog__orders {
    padding: 18px 14px 0;
  }
  .hn-order-timeline {
    margin-top: 13px;
  }
  .hn-order-timeline > li {
    gap: 8px;
  }
  .hn-order-timeline article > dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .hn-order-timeline article > dl > div:nth-child(3) {
    border-left: 0;
    border-top: 1px solid var(--hn-line);
  }
  .hn-order-timeline article > dl > div:nth-child(4) {
    border-top: 1px solid var(--hn-line);
  }
  .hn-order-fills li {
    gap: 5px 10px;
    grid-template-columns: minmax(0, 1fr) auto;
    padding: 8px 0;
  }
  .hn-order-fills time {
    grid-column: 1/-1;
  }
  .hn-cycle-dialog__settlement {
    padding: 18px 14px 22px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .hn-cycle-summary {
    transition: none;
  }
  .hn-cycle-summary:hover {
    transform: none;
  }
}`],
})
export class ComponentCycleHistoryComponent implements OnDestroy {
    @Input() cycles: any[] = [];
    @Input() fills: any[] = [];
    @Input() compact = false;
    public selectedCycleId = '';
    public detail: any = null;
    public detailLoading = false;
    public detailError = '';
    private requestVersion = 0;
    private previousBodyOverflow = '';

    constructor(@Inject( Service) public service: Service) { }

    public ngOnDestroy() {
        this.restorePageScroll();
    }

    @HostListener('document:keydown.escape')
    public closeOnEscape() {
        if (this.selectedCycleId) this.closeDetail();
    }

    public async openDetail(cycleId: any) {
        const id = String(cycleId || '').trim();
        if (!id) return;
        const requestVersion = ++this.requestVersion;
        this.selectedCycleId = id;
        this.detail = null;
        this.detailError = '';
        this.detailLoading = true;
        this.lockPageScroll();
        await this.service.render();
        try {
            const { code, data } = await wiz.call('cycle_detail', {
                cycle_id: id
            });
            if (requestVersion !== this.requestVersion) return;
            if (code !== 200 || !data) {
                throw new Error(data?.message || '상세 기록을 불러오지 못했습니다.');
            }
            this.detail = data;
        } catch (error: any) {
            if (requestVersion !== this.requestVersion) return;
            this.detailError = error?.message || '상세 기록을 불러오지 못했습니다.';
        } finally {
            if (requestVersion === this.requestVersion) {
                this.detailLoading = false;
                await this.service.render();
            }
        }
    }

    public closeDetail() {
        this.requestVersion += 1;
        this.selectedCycleId = '';
        this.detail = null;
        this.detailError = '';
        this.detailLoading = false;
        this.restorePageScroll();
    }

    public closeFromBackdrop(event: any) {
        if (event?.target === event?.currentTarget) this.closeDetail();
    }

    public retryDetail() {
        this.openDetail(this.selectedCycleId);
    }

    private lockPageScroll() {
        if (!this.previousBodyOverflow) {
            this.previousBodyOverflow = document.body.style.overflow || 'unset';
        }
        document.body.style.overflow = 'hidden';
    }

    private restorePageScroll() {
        if (!this.previousBodyOverflow) return;
        document.body.style.overflow = this.previousBodyOverflow === 'unset'
            ? '' : this.previousBodyOverflow;
        this.previousBodyOverflow = '';
    }

    public trackById(_index: number, item: any) {
        return item?.id;
    }

    public cycleStatus(cycle: any) {
        if (cycle?.display_status === 'NO_FILL') return '미체결 종료';
        return cycle?.status === 'COMPLETE' ? '완료' : '진행 중';
    }

    public cyclePeriod(cycle: any) {
        const start = this.formatDay(cycle?.entry_date || cycle?.entry_at);
        if (cycle?.status !== 'COMPLETE') return `${start} 시작`;
        const end = this.formatDay(cycle?.completed_at);
        return start === end || end === '-' ? start : `${start} – ${end}`;
    }

    public cycleFillCount(cycleId: any) {
        const cycle = this.cycles.find((item: any) => (
            String(item?.id || '') === String(cycleId || '')
        ));
        const count = Number(cycle?.fill_count);
        if (Number.isFinite(count) && count >= 0) return count;
        return this.fills.filter((item: any) => (
            item?.kind !== 'CYCLE_COMPLETE'
            && String(item?.cycle_id || '') === String(cycleId || '')
        )).length;
    }

    public latestFill(cycleId: any) {
        return this.fills.find((item: any) => (
            item?.kind !== 'CYCLE_COMPLETE'
            && String(item?.cycle_id || '') === String(cycleId || '')
        ));
    }

    public recentCycleFills(cycleId: any) {
        return this.fills.filter((item: any) => (
            item?.kind !== 'CYCLE_COMPLETE'
            && String(item?.cycle_id || '') === String(cycleId || '')
        )).sort((a: any, b: any) => (
            this.fillTimestamp(b) - this.fillTimestamp(a)
        )).slice(0, 3);
    }

    private fillTimestamp(fill: any) {
        return Date.parse(fill?.executed_at || fill?.occurred_at || '') || 0;
    }

    public formatFillTime(value: any) {
        const date = new Date(value);
        if (!value || Number.isNaN(date.getTime())) return '-';
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul', month: 'numeric', day: 'numeric',
            hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        }).format(date);
    }

    public roleLabel(role: any) {
        const value = String(role || '');
        const addSell = value.match(/^ADD_SELL_(\d+)_(\d+)$/);
        if (addSell) return `추가 ${addSell[1]}차 물량 ${addSell[2]}차 매도`;
        const numbered: Array<[RegExp, string]> = [
            [/^ADD_BUY_(\d+)$/, '차 추가 매수'],
            [/^REBUY_(\d+)$/, '차 재매수'],
            [/^RECYCLE_SELL_(\d+)$/, '차 재매수분 매도'],
            [/^(?:PARTIAL_SELL|EXIT)_(\d+)$/, '차 분할 매도']
        ];
        for (const [pattern, suffix] of numbered) {
            const match = value.match(pattern);
            if (match) return `${match[1]}${suffix}`;
        }
        const labels: any = {
            INITIAL_BUY: '첫 매수',
            FINAL_SELL: '마지막 매도',
            RECYCLE_SELL: '재매수분 매도'
        };
        return labels[value] || '주문';
    }

    public statusLabel(status: any) {
        const labels: any = {
            NEW: '접수', OPEN: '대기', PENDING: '대기', SUBMITTED: '접수',
            PARTIALLY_FILLED: '일부 체결', FILLED: '체결',
            CANCELLED: '취소', CANCELED: '취소', REJECTED: '거절',
            UNKNOWN: '확인 필요'
        };
        return labels[String(status || '').toUpperCase()] || '확인';
    }

    public orderProgress(order: any) {
        const requested = Number(order?.requested_quantity || 0);
        const filled = Number(order?.filled_quantity || 0);
        return requested > 0 ? Math.min(100, filled * 100 / requested) : 0;
    }

    public orderPrice(order: any) {
        return Number(order?.average_fill_price || order?.limit_price || 0);
    }

    public formatNumber(value: any) {
        return Number(value || 0).toLocaleString('ko-KR');
    }

    public formatPrice(value: any) {
        const price = Number(value || 0);
        return price > 0 ? `${price.toLocaleString('ko-KR')}원` : '-';
    }

    public formatMoney(value: any, signed = false) {
        const amount = Number(value || 0);
        const prefix = signed && amount > 0 ? '+' : '';
        return `${prefix}${amount.toLocaleString('ko-KR')}원`;
    }

    public formatDay(value: any) {
        if (!value) return '-';
        const source = String(value);
        const date = new Date(source.includes('T') ? source : `${source}T00:00:00+09:00`);
        if (Number.isNaN(date.getTime())) return source;
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul', month: 'numeric', day: 'numeric'
        }).format(date);
    }

    public formatDateTime(value: any) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '-';
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit'
        }).format(date);
    }

    public formatVersion(version: any) {
        const match = String(version || '').match(/v\d+(?:\.\d+)?/i);
        return match ? match[0].toLowerCase() : '';
    }
}

export default ComponentCycleHistoryComponent;